var React = require('react');
var createReactTimeout = require('./reactTimeout.js');
module.exports = createReactTimeout(React);